var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "modal-job-monitoring", attrs: { id: "idModalCancelJob" } },
    [
      _c("div", { staticClass: "wrap-modal-job-monitoring" }, [
        _c("img", {
          attrs: {
            src: require("@/assets/icon/cancel-job.svg"),
            alt: "cancel-job-icon"
          }
        }),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _c("p", { staticClass: "info" }, [_vm._v("All Current Waiting Job")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "button-modal-job-monitoring" },
          [
            _c(
              "b-button",
              {
                staticClass: "btn-cancel-waiting",
                on: { click: _vm.handleCancelJob }
              },
              [_vm._v("\n        Yes\n      ")]
            ),
            _vm._v(" "),
            _c("b-button", { on: { click: _vm.closeModalCancelJob } }, [
              _vm._v("\n        Cancel\n      ")
            ])
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "title" }, [
      _vm._v("Are you sure to "),
      _c("span", { staticClass: "cancel" }, [_vm._v("Cancel")]),
      _vm._v(" ?")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7515c85c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7515c85c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/visual-programming/popup/ModalCancelJob.vue
// module id = null
// module chunks = 